// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"60058268709b31d0a6b3","418":"bbbdd39ff9b7982db2c6","661":"b8724029c3168c68e15f"}[chunkId] + ".js";
};